import React, {ReactNode} from "react";
import useScrollableWithFade from "@Containers/hooks/useScrollableWithFade";

interface ScrollableWithFadeProps {
    classNames: string,
    numberOfItemsDisplayed: number,
    children: ReactNode[]
}

function ScrollableWithFade({classNames, numberOfItemsDisplayed, children}: ScrollableWithFadeProps) {
    const {
        containerRef,
        fadeClass,
    } = useScrollableWithFade(numberOfItemsDisplayed)

    return (
        <div className={fadeClass}>
            <div className={classNames} ref={containerRef}>
                {children}
            </div>
        </div>
    )
}

export default ScrollableWithFade